import marvinImg from "../..//resources/marvinGaye.jpg";
import beckImg from "../..//resources/beck.jpg";
import pinkFloydImg from "../..//resources/pinkFloyd.jpg";
import blondieImg from "../..//resources/blondie.jpeg";
import milesDavisImg from "../..//resources/milesDavis.jpg";

// list of artists for reference
const marvinGaye = {
    name: 'Marvin Gaye',
    ref: "3koiLjNrgRTNbOwViDipeA",
    image: marvinImg
}
const beck = {
    name: 'Beck',
    ref: "3vbKDsSS70ZX9D2OcvbZmS",
    image: beckImg
}
const pinkFloyd = {
    name: 'Pink Floyd',
    ref: "0k17h0D3J5VfsdmQ1iZtE9",
    image: pinkFloydImg
}
const blondie = {
    name: 'Blondie',
    ref: "4tpUmLEVLCGFr93o8hFFIB",
    image: blondieImg
}
const miles = {
    name: 'Miles Davis',
    ref: "0kbYTNQb4Pb1rPbbaF0pT4",
    image: milesDavisImg
}


const starterArtist = [beck, marvinGaye, pinkFloyd, blondie, miles];

export default starterArtist;
